/* eslint-disable class-methods-use-this */

/* eslint-disable no-shadow */
import axios from "axios";

import {
  API_ANNOUNCEMENT_URL,
  API_NOTIFICATION_URL,
  COMMON_HEADER_CONFIG
} from "../config";

class NotificationService {
  getAccessToken = () => localStorage.getItem("accessToken");

  searchNotificationRules = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_NOTIFICATION_URL}/notification-rules`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          size: 100,
          page: 1,
          ...data
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data.data && response.data.code === "success") {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListNotificationRules = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_NOTIFICATION_URL}/notification-rules?`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          size: 100,
          page: 1
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  // create customer
  createNotification = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_NOTIFICATION_URL}/notification-rule`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOneNotification = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_NOTIFICATION_URL}/notification-rule/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateNotification = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "patch",
        url: `${API_NOTIFICATION_URL}/notification-rule/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteNotification = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "DELETE",
        url: `${API_NOTIFICATION_URL}/notification-rule/${data}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteNotificationInfo = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "DELETE",
        url: `${API_NOTIFICATION_URL}/notification-info/${data}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListState = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ANNOUNCEMENT_URL}/meta-data?`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          platform_key: "centralweb",
          type: "order_state"
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListPaymentMethod = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ANNOUNCEMENT_URL}/meta-data?`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          platform_key: "centralweb",
          type: "payment_method"
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListNotificationInfos = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_NOTIFICATION_URL}/notification-infos?`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          page: 1,
          per_page: 100,
          sort: "created_at DESC",
          ...data
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data.data) {
            const data = {
              data: response.data.data,
              length: response.headers["x-total-items"]
            };
            resolve(data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getNotificationContentReplace = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_NOTIFICATION_URL}/notification/content-replace`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  // send all notification
  getListNotificationMessage = (params) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_NOTIFICATION_URL}/notification/messages`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          per_page: 100,
          page: 1,
          ...params
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data.code === "success") {
            resolve(response);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOneNotificationMessage = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_NOTIFICATION_URL}/notification/message/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  sendAllNotificationMessage = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_NOTIFICATION_URL}/notification/message/send-all`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createNotificationMessage = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_NOTIFICATION_URL}/notification/message`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateNotificationMessage = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_NOTIFICATION_URL}/notification/message/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteNotificationMessage = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_NOTIFICATION_URL}/notification/message/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        }
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListHistoryNotificationMessage = (params) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_NOTIFICATION_URL}/notification/history-message`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          per_page: 100,
          page: 1,
          ...params
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data.code === "success") {
            resolve(response);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const notificationService = new NotificationService();

export default notificationService;
